/**
* Error Page JS
* -----------------------------------------------------------------------------
*
* All the JS for the Error Page component.
*/

/*
 * Example of importing modules if needed. Like for scroll magic / gsap
 */

import {gsap} from 'gsap';
import {ScrollTrigger} from 'gsap/ScrollTrigger.js';
( function( app ) {
  const COMPONENT = {

    className: 'error-page',
    selector: function() {
      return '.' + this.className;
    },
    // Fires after common.init, before .finalize and common.finalize
    init: function() {
      gsap.registerPlugin( ScrollTrigger );

      /* Error page animation */
      const errorSvg = document.querySelector( '.error__logo' );
      const errorPaths = errorSvg.querySelectorAll( '.logo__svg-path' );

      function drawLogo() {
        errorPaths.forEach( ( path ) => {
          const length = path.getTotalLength();

          path.style.strokeDasharray = length;
          path.style.strokeDashoffset = length;
          path.style.opacity = '0';

          setTimeout( () => {
            path.style.transition = 'opacity 150ms ease-out, stroke-dashoffset 1.5s ease-in-out';
            path.style.opacity = '1';

            setTimeout( () => {
              path.style.strokeDashoffset = '0';
            }, 0 );
          }, 150 );
        } );
      }

      const errorPageSection = document.querySelector( '.error-page' );
      const observer = new IntersectionObserver( ( entries, observerInstance ) => {
        entries.forEach( ( entry ) => {
          if ( entry.isIntersecting ) {
            drawLogo();
            observerInstance.unobserve( entry.target );
          }
        } );
      }, {threshold: 0.5} );

      if ( errorPageSection ) {
        observer.observe( errorPageSection );
      }
    },
    finalize: function() {
    },
  };

  // Hooks the component into the app
  app.registerComponent( 'error-page', COMPONENT );
} )( app );
